import { render, staticRenderFns } from "./CreaRedefinicionFila.vue?vue&type=template&id=58cfd16f"
import script from "./CreaRedefinicionFila.vue?vue&type=script&lang=js"
export * from "./CreaRedefinicionFila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports